
<div class='selector'>
  <div class='selector-container'>
    <div class='selector-arrow selector-arrow_left' @click='moveToPreviousService()'></div>
    <div class="selector-txt-container selector-txt-services">
      <div class='selector-ico-services'></div>
      <div id='serviceToPrint' class='selector-txt'>
        {{ getSelectedSubService }}
      </div>
      <el-select v-model="valueSelect" value-key="id" @change="setSelectedServiceC">
        <el-option v-for="item in getSelectedDayServicesData" :key="item.id" :label="item.name" :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div class='selector-arrow selector-arrow_right' @click='moveToNextService()'></div>
  </div>
</div>
